import React from 'react';
import ComplaintCard from './ComplaintCard';

interface ComplaintData {
  uuid: string;
  accountUuid: string;
  complaintId: string;
  complaintType: string;
  message: string;
  contact_info: string | null;
  createdAt: string;
  subComplaintType: string;
}
interface IProps {
  complaints: ComplaintData[];
  selectedComplaintsInfo: any;
  setSelectedComplaintsInfo: any;
}

const ListOfComplaints = (props: IProps) => {
  const { complaints, selectedComplaintsInfo, setSelectedComplaintsInfo } = props;
  return (
    <div className="flex flex-col gap-2.5 xl:overflow-y-auto p-2 md:pr-2.5">
      {complaints.map((info: ComplaintData, index) => (
        <ComplaintCard
          info={info}
          selectedComplaintsInfo={selectedComplaintsInfo}
          setSelectedComplaintsInfo={setSelectedComplaintsInfo}
          key={index}
        />
      ))}
    </div>
  );
};

export default ListOfComplaints;
